module.exports = __webpack_public_path__ + "img/pop-up-zold-ikon.4a8fcf76.svg";